<template>
  <TransitionGroup
    v-if="group"
    name="fade-transition"
    appear>
    <slot/>
  </TransitionGroup>
  <Transition
    v-else
    name="fade-transition"
    mode="out-in"
    appear>
    <slot/>
  </Transition>
</template>

<script setup>
defineProps({
  group: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss">
.fade-transition {
  &-enter-active,
  &-leave-active {
    transition: opacity 1s ease;
  }
  &-leave-active {
    position: absolute !important;
  }

  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}
</style>
